import React from 'react';

function GeometricBackground() {
  // Increased from 40 to 45 for larger circles
  const RADIUS = 45; 

  return (
    <div className="geo-bg" aria-hidden="true">
      {/* Outer vertical lines (midway to edges) */}
      <div className="geo-line geo-vline-outer-left" />
      <div className="geo-line geo-vline-outer-right" />
      
      {/* Inner vertical lines (tangents to the circle) */}
      <div className="geo-line geo-vline-inner-left" />
      <div className="geo-line geo-vline-inner-right" />

      <svg
        className="geo-svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Main central circle */}
        <circle className="geo-stroke" cx="50" cy="50" r={RADIUS} />

        {/* Top circle (Tangent to the top pole of the central circle) */}
        <circle
          className="geo-stroke"
          cx="50"
          cy={50 - (RADIUS * 2)}
          r={RADIUS}
        />

        {/* Bottom circle (Tangent to the bottom pole of the central circle) */}
        <circle
          className="geo-stroke"
          cx="50"
          cy={50 + (RADIUS * 2)}
          r={RADIUS}
        />
      </svg>
    </div>
  );
}

export default GeometricBackground;